module.exports = __webpack_public_path__ + "static/media/BatchReportIcon.a8433e45.svg";